import { TRUSTED_SUPPLIERS } from "@/data/site";

// Sliding marquee of trusted supplier/client brands.
// Uses real logo images when provided; falls back to a styled wordmark tile.
const LogoMarquee = ({ label = "TRUSTED BY LEADING CHAINS AND BUSINESSES:" }) => {
  const loop = [...TRUSTED_SUPPLIERS, ...TRUSTED_SUPPLIERS];
  return (
    <section className="bg-[#1E2D40] py-10 overflow-hidden border-y border-white/5" data-testid="logo-marquee">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 mb-6">
        <div className="text-[#E8721C] tracking-[.22em] text-[11px] md:text-[12px] font-bold">
          {label}
        </div>
      </div>
      <div className="marquee relative">
        <div className="marquee-track" data-testid="marquee-track">
          {loop.map((s, i) => (
            <div
              key={`${s.name}-${i}`}
              className="logo-tile"
              data-testid={`logo-${s.name.toLowerCase().replace(/[^a-z0-9]+/g,'-')}`}
              title={s.name}
            >
              {s.logo ? (
                <img
                  src={s.logo}
                  alt={s.name}
                  loading="lazy"
                  className="max-h-[68px] max-w-[180px] object-contain"
                />
              ) : (
                <div className="text-center">
                  <div>{s.name}</div>
                  <small>{s.tagline}</small>
                </div>
              )}
            </div>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#1E2D40] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#1E2D40] to-transparent" />
      </div>
    </section>
  );
};

export default LogoMarquee;
